module.exports = __webpack_public_path__ + "img/github.14136bc4.svg";